function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1512 2000",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2477.82,-69.5527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,612.885,55.9224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,387.116C93.423,399.078 186.558,411.329 281.025,422.244C295.071,299.554 311.371,179.12 326.352,57.365C265.972,48.621 203.135,42.337 142.779,33.569C139.508,55.119 147.76,69.397 141.646,86.828C133.965,108.721 99.616,107.541 92.92,86.828C87.455,69.926 94.657,48.794 91.787,27.903C77.319,25.373 62.201,23.493 46.46,22.237C30.023,142.91 15.695,265.699 0,387.116M100.852,-3.825C123.678,-3.462 97.565,81.005 115.583,84.561C128.219,87.055 124.648,60.071 124.648,44.9C124.648,24.32 127.089,9.206 124.648,-3.825C120.884,-23.92 90.763,-28.12 83.854,-10.625C82.225,-6.497 77.676,7.195 89.52,8.639C94.414,0.628 91.774,-3.971 100.852,-3.825M142.779,14.305C200.298,13.6 262.78,5.955 317.287,9.772C321.253,16.004 318.846,28.609 320.686,36.969C327.493,40.36 340.288,37.764 344.482,43.767C344.509,91.697 331.193,142.4 327.485,193.345C324.726,231.26 330.211,270.99 332.018,308.928C333.838,347.161 336.11,384.96 333.151,422.244C324.484,426.043 310.554,424.577 299.156,425.644C296.811,430.097 298.418,438.504 293.49,440.375C262.526,442.603 229.316,432.56 193.771,430.177C133.4,426.129 68.307,441.508 10.199,434.709C4.932,429.778 7.318,417.194 6.799,407.513C-0.194,403.93 -13.818,406.978 -18.13,400.715C-19.542,349.288 -1.491,295.865 0,240.938C1.952,169.036 -12.122,94.745 -6.799,23.37C0.442,17.768 15.667,20.151 27.196,18.838C26.165,-2.324 45.791,2.403 62.324,5.24C58.08,-55.487 154.983,-55.483 142.779,14.305",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,851.983,197.323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.618C7.441,16.139 17.087,20.055 24.93,30.415C31.629,39.265 46.104,68.452 29.462,75.741C17.864,80.821 -16.972,71.968 -31.729,70.076C-47.057,68.11 -90.152,68.305 -92.919,53.078C-97.364,28.62 -60.281,10.398 -43.061,2.086C-42.525,-8.565 -51.367,-12.622 -52.125,-23.977C-54.727,-62.901 -2.777,-74.203 13.598,-43.241C23.324,-24.849 12.021,-7.387 0,6.618",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,704.672,286.215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.447C1.259,7.749 -1.531,11.003 -4.533,14.045C-19.548,10.854 -49.307,16.234 -49.859,1.58C-50.514,-15.787 -11.582,-5.692 0,0.447",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0428119,-0.999083,-0.999083,0.0428119,757.41,259.937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39.888,-41.912C-45.094,-43.446 -48.105,-42.144 -52.293,-40.246C-54.226,-16.737 -46.932,15.982 -39.888,37.482C-37.943,39.336 -24.69,39.31 -25.414,31.191C-26.856,14.96 -34.05,-32.244 -39.888,-41.912",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.611446,0.791286,0.791286,0.611446,885.285,296.971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.594,-45.86C31.662,-41.936 2.386,7.926 8.578,14.665C20.817,27.986 30.882,0.276 39.594,-14.355C46.382,-25.756 56.259,-37.475 52.025,-43.415C47.74,-49.424 42.473,-47.285 39.594,-45.86",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,657.079,354.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-35.4C7.091,-38.801 24.689,-34.402 35.128,-33.133C59.876,-30.129 78.13,-27.563 105.384,-24.068C118.82,-22.345 133.394,-21.925 132.58,-11.603C131.397,3.401 78.917,-8.488 63.457,-10.47C51.667,-11.982 -3.515,-13.648 -5.666,-25.202C-6.805,-31.317 -4.391,-33.295 0,-35.4",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,814.589,365.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-26.831C6.63,-29.531 24.98,-25.169 38.528,-23.432C50.466,-21.901 74.396,-23.267 71.389,-8.7C69.036,2.7 42.743,-3.917 31.729,-5.301C20.865,-6.666 -4.436,-6.268 -6.799,-15.499C-8.364,-21.612 -3.985,-25.209 0,-26.831",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.169911,-0.985459,-0.985459,-0.169911,699.621,347.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30.891,-16.201C-35.414,-6.063 -34.938,5.234 -35.55,17.492C-35.926,25.016 -38.817,48.134 -30.891,50.492C-27.556,51.485 -18.851,50.547 -18.376,44.601C-16.981,27.145 -7.889,-28.482 -30.891,-16.201",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,730.735,406.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-38.265C34.251,-34.775 78.137,-29.679 118.982,-24.667C129.235,-23.41 150.667,-22.488 146.178,-8.803C143.291,0 123.016,-4.992 111.05,-6.536C73.029,-11.444 28.334,-14.911 -4.533,-23.535C-7.308,-29.405 -4.752,-36.499 0,-38.265",
    style: {
      fill: "rgb(29,29,27)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,645.747,435.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-36.713C0.698,-37.05 0.833,-37.968 2.267,-37.846C25.148,-35.894 65.651,-30.511 96.319,-26.515C110.141,-24.713 123.58,-25.164 121.249,-12.916C118.551,1.255 69.25,-11.525 57.792,-12.916C46.233,-14.319 35.817,-14.702 22.664,-16.316C13.805,-17.402 -3.774,-18.669 -5.666,-25.381C-7.39,-31.501 -4.647,-34.465 0,-36.713",
    style: {
      fill: "rgb(29,29,27)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.4b3b09b25ace7d74249abff2e43063aa.svg";
export { ForwardRef as ReactComponent };